module.exports = __webpack_public_path__ + "static/media/btn.a3b6864d.png";